import { Injectable } from '@angular/core';
import { ThermalPrintOptions, ThermalPrintService } from './thermal-print.service';

/**
 * Impressão de cupons térmicos no navegador (nuvem): busca JSON na API e imprime via `window.print()`.
 * Não utiliza printBridge/CefSharp.
 */
@Injectable({
  providedIn: 'root'
})
export class PrintService {
  constructor(private thermalPrint: ThermalPrintService) {}

  printSaleReceipt(saleId: number, options?: ThermalPrintOptions): void {
    this.thermalPrint.printSaleReceipt(saleId, options);
  }

  printCashOpen(pdvId: number, options?: ThermalPrintOptions): void {
    this.thermalPrint.printCashOpen(pdvId, options);
  }

  printCashClose(pdvId: number, options?: ThermalPrintOptions): void {
    this.thermalPrint.printCashClose(pdvId, options);
  }

  printCrediarioInstallments(saleId: number, options?: ThermalPrintOptions): void {
    this.thermalPrint.printCrediarioInstallments(saleId, options);
  }
}
